var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "dialog_class",
      attrs: {
        id: "problemOrderTracking",
        title: _vm.data.title,
        visible: _vm.isShow,
        width: "1000px",
        "close-on-click-modal": false,
      },
      on: {
        close: _vm.closeDialog,
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "timeline",
        },
        [
          _c(
            "div",
            {
              staticClass: "orderInfo",
              staticStyle: { "margin-bottom": "10px" },
            },
            [
              _vm.isYto
                ? _c("span", { staticStyle: { "margin-right": "20px" } }, [
                    _vm._v("物流公司：圆通速递"),
                  ])
                : _vm.companyName
                ? _c("span", { staticStyle: { "margin-right": "20px" } }, [
                    _vm._v("物流公司：" + _vm._s(_vm.companyName)),
                  ])
                : _vm._e(),
              _c("span", [_vm._v("运单号：" + _vm._s(_vm.data.code))]),
              _c(
                "span",
                {
                  staticClass: "favoritesFolder",
                  class: { active: _vm.isIncluded },
                  on: {
                    click: function ($event) {
                      return _vm.changeCollectBtn(_vm.data.code)
                    },
                  },
                },
                [
                  _vm.isIncluded
                    ? _c("svg-icon", {
                        staticClass: "icon-svg-print-style",
                        attrs: { "icon-class": "icon_shoucang_no" },
                      })
                    : _c("svg-icon", {
                        staticClass: "icon-svg-print-style",
                        attrs: { "icon-class": "icon_shoucang_yes" },
                      }),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(_vm._s(_vm.isIncluded ? "取消收藏" : "收藏单号")),
                  ]),
                  _vm.curActiveCollectIndex
                    ? _c("span", { staticClass: "cancelCollect" }, [
                        _c("span", { staticClass: "confirm_tip" }, [
                          _vm._v("确认取消收藏吗？"),
                        ]),
                        _c("span", { staticClass: "confirm_btn" }, [
                          _c(
                            "span",
                            {
                              staticClass: "flag_btn",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  _vm.curActiveCollectIndex = false
                                },
                              },
                            },
                            [_vm._v("取消")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "flag_btn confirm",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.cancelCollectWaybill(_vm.data.code)
                                },
                              },
                            },
                            [_vm._v("确认")]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "orderInfo", staticStyle: { "margin-bottom": "0" } },
            [
              _vm.data.kcode || _vm.data.kname
                ? _c("span", { staticStyle: { "margin-right": "20px" } }, [
                    _vm._v(" 客户信息： "),
                    _vm.data.kcode
                      ? _c("span", [_vm._v(_vm._s(_vm.data.kcode))])
                      : _vm._e(),
                    _vm.data.kcode && _vm.data.kname
                      ? _c("span", [_vm._v(" - ")])
                      : _vm._e(),
                    _vm.data.kname
                      ? _c("span", [_vm._v(_vm._s(_vm.data.kname))])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.data.sellerName
                ? _c("span", { staticStyle: { "margin-right": "20px" } }, [
                    _vm._v("商家信息：" + _vm._s(_vm.data.sellerName)),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "flex",
              staticStyle: { width: "100%", "justify-content": "center" },
            },
            [
              _c("div", { staticStyle: { width: "50%" } }, [
                _c("div", { staticClass: "yto-title" }, [_vm._v("收件信息")]),
                _c("div", { staticClass: "info-box" }, [
                  _c("p", { staticClass: "flex" }, [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("姓名："),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.info.receiverName))]),
                  ]),
                  _c("div", { staticClass: "flex" }, [
                    _c("p", { staticClass: "flex phone-div" }, [
                      _c("span", { staticClass: "info-title" }, [
                        _vm._v("手机号码："),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.info.receiverMobile))]),
                    ]),
                    _c("p", { staticClass: "flex phone-div" }, [
                      _c("span", { staticClass: "info-title" }, [
                        _vm._v("电话号码："),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.info.receiverPhone))]),
                    ]),
                  ]),
                  _c("p", { staticClass: "flex" }, [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("收货地址："),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.info.receiverProvName) +
                          _vm._s(_vm.info.receiverCityName) +
                          _vm._s(_vm.info.receiverTownName) +
                          _vm._s(_vm.info.receiverAddress)
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticStyle: { width: "50%" } }, [
                _c("div", { staticClass: "yto-title" }, [_vm._v("寄件信息")]),
                _c("div", { staticClass: "info-box" }, [
                  _c("p", { staticClass: "flex" }, [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("姓名："),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.info.senderName))]),
                  ]),
                  _c("div", { staticClass: "flex" }, [
                    _c("p", { staticClass: "flex phone-div" }, [
                      _c("span", { staticClass: "info-title" }, [
                        _vm._v("手机号码："),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.info.senderMobile))]),
                    ]),
                    _c("p", { staticClass: "flex phone-div" }, [
                      _c("span", { staticClass: "info-title" }, [
                        _vm._v("电话号码："),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.info.senderPhone))]),
                    ]),
                  ]),
                  _c("p", { staticClass: "flex" }, [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v("收货地址："),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.info.senderProvName) +
                          _vm._s(_vm.info.senderCityName) +
                          _vm._s(_vm.info.senderTownName) +
                          _vm._s(_vm.info.senderAddress)
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
          _c("div", { staticStyle: { width: "100%" } }, [
            _c("div", { staticClass: "yto-title" }, [_vm._v("售后信息")]),
            _c(
              "div",
              { staticStyle: { padding: "0 40px" } },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.tableData, border: "" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "afterSaleType",
                        align: "center",
                        label: "工单类型",
                        width: "80",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.afterSaleType == 1
                                ? _c("span", [_vm._v("发起的")])
                                : _vm._e(),
                              scope.row.afterSaleType == 2
                                ? _c("span", [_vm._v("收到的")])
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "problemTypeName",
                        align: "center",
                        label: "问题类型",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "launchTime",
                        align: "center",
                        label: "发起/生成时间",
                        width: "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "dealTypeName",
                        align: "center",
                        label: "处理状态",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "dealDesc",
                        align: "center",
                        label: "处理结果",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "yto-title" }, [_vm._v("物流信息")]),
          _vm.orderData.length > 0 && _vm.orderData[0].documents
            ? _c(
                "div",
                {
                  staticClass: "alert-warning",
                  staticStyle: {
                    "text-align": "left",
                    padding: "0px 0px 10px 0px",
                  },
                },
                [
                  _c(
                    "el-alert",
                    {
                      attrs: {
                        type: "warning",
                        "show-icon": "",
                        closable: false,
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.orderData[0].documents))])]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.orderData.length > 0
            ? _c(
                "ul",
                _vm._l(_vm.orderData, function (item, i) {
                  return _c(
                    "li",
                    { key: i, staticClass: "timeline-item-first" },
                    [
                      _vm.isYto
                        ? [
                            _c("div", { staticClass: "timeline-item-time" }, [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getDateTime(
                                      item.waybillProcessInfo["upload_Time"]
                                    )
                                  )
                                ),
                              ]),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getDateTime(
                                      item.waybillProcessInfo["upload_Time"],
                                      1
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "timeline-item-color" }, [
                              _c("i", { staticClass: "circle-icon" }),
                            ]),
                            _c("div", { staticClass: "timeline-item-tail" }),
                            _c(
                              "div",
                              { staticClass: "timeline-item-content flex" },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getProcessInfo(
                                        item.waybillProcessInfo["processInfo"]
                                      )
                                    )
                                  ),
                                ]),
                                item.opOrgCode && i == 0
                                  ? _c("div", {
                                      staticClass: "view-icon",
                                      on: {
                                        click: (event) => {
                                          _vm.viewOrg(event, item)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        : [
                            _c("div", { staticClass: "timeline-item-time" }, [
                              _c("h3", [
                                _vm._v(_vm._s(_vm.getDateTime(item["time"]))),
                              ]),
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.getDateTime(item["time"], 1))
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "timeline-item-color" }, [
                              _c("i", { staticClass: "circle-icon" }),
                            ]),
                            _c("div", { staticClass: "timeline-item-tail" }),
                            _c(
                              "div",
                              { staticClass: "timeline-item-content flex" },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.getProcessInfo(item["context"]))
                                  ),
                                ]),
                              ]
                            ),
                          ],
                    ],
                    2
                  )
                }),
                0
              )
            : _c("el-alert", {
                attrs: {
                  title: "暂无走件流程",
                  type: "info",
                  closable: false,
                  "show-icon": "",
                },
              }),
        ],
        1
      ),
      _c("branch-org", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showBranchOrgDialog,
            expression: "showBranchOrgDialog",
          },
        ],
        attrs: { dialogOption: _vm.dialogOption, opOrgCode: _vm.opOrgCode },
        on: {
          closeDialog: function ($event) {
            _vm.showBranchOrgDialog = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }